export class Mois {

  constructor(code, libelle, annee) {
    this.code = code;
    this.libelle = libelle;
    this.annee = annee;
  }
}
